/**
 * Rescate de una copia guardada que ya no vale.
 *
 * El navegador guarda la aplicacion entera para que funcione sin cobertura
 * (es una PWA). El precio es que, hasta que esa copia se renueva, la web
 * puede responder como la version de hace tres despliegues: no conoce las
 * pantallas nuevas y, cuando alguien va a una, pinta un 404 que no es verdad.
 *
 * Dar de baja el service worker es mas contundente que actualizarlo: la
 * pagina deja de estar controlada, asi que la siguiente carga va a la red
 * seguro. Se vuelve a registrar solo en la visita siguiente.
 */
export async function unregisterServiceWorkers(): Promise<void> {
  try {
    const registrations = (await navigator.serviceWorker?.getRegistrations()) ?? [];
    await Promise.all(registrations.map((registration) => registration.unregister()));
  } catch {
    // Sin service worker (o sin permiso para verlo) no hay nada que dar de baja.
  }
}

/** Direcciones que pertenecen al panel, que es otra aplicacion. */
export function isAdminPath(pathname: string): boolean {
  return (
    pathname === '/admin' ||
    pathname.startsWith('/admin/') ||
    pathname.startsWith('/admin.html')
  );
}

const CANDADO = 'cp.admin-rescue';

/**
 * Candado del rescate: se intenta UNA vez por direccion y sesion.
 *
 * Sin el, una direccion que de verdad no existe recargaria para siempre.
 * Devuelve `true` si ya se intento (y entonces no se vuelve a intentar).
 * Si sessionStorage esta bloqueado —ventana privada, cookies cortadas— dice
 * que si: mejor no recargar que arriesgar un bucle.
 */
export function rescueAlreadyTried(pathname: string): boolean {
  try {
    if (sessionStorage.getItem(CANDADO) === pathname) return true;
    sessionStorage.setItem(CANDADO, pathname);
    return false;
  } catch {
    return true;
  }
}

/** Hay una copia guardada sirviendo esta pagina. */
export function servedByServiceWorker(): boolean {
  try {
    return Boolean(navigator.serviceWorker?.controller);
  } catch {
    return false;
  }
}
